const searchExpandedTreeItems = (nodeId, nodes) => {
    if (nodeId) {
        for (const node of nodes) {
            if (node.id === nodeId) {
                return [node.id];
            }
            else if (node.children && node.children.length > 0) {
                const found = searchExpandedTreeItems(nodeId, node.children);
                if (found.length > 0) {
                    found.push(node.id);
                    return found;
                }
            }
        }
    }
    return [];
};
export default searchExpandedTreeItems;
